import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"

Vue.use(AclInstaller)

let initialRole = "administrador"

let userInfo = JSON.parse(localStorage.getItem("userInfo"))
if (userInfo && userInfo.role) {
  initialRole = userInfo.role.name
}

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule("administrador").generate(),
    check: new AclRule("*").generate(),
    all: new AclRule("*").generate()
  }
})
